<template>
	<div id="homeMain">
		<el-row  style="width:100%">
			<el-col class="left_Content" :xl='17' >
				<div class="quick">
					<el-row>
							<el-col :span="12" class="miniTitle">快捷入口</el-col>
							<el-col :span="12" style="text-align:right">
								<span class="edit" @click='CommonFunctionsShow'><i class="el-icon-edit" ></i>自定义</span>
							</el-col>
					</el-row>
					<div class="quick-items">
						<div class="quick-item" v-for='i in commonList' :key='i.id'  @click='handleClickJump(i)'>
							<img :src="'/static/home/'+i.icon+'.png'" alt="" width="46" height="46">
							<span>{{i.name}}</span>
						</div>
					</div>
				</div>
				<div class="content">
					<div class="money" v-loading = "loading">
						<div class="miniTitle">资金总览</div>
						<div class="money_num">
							<div class="surplus">
								<div>余额</div>
								<Moneys  :value='inComeAndOutInfo.balance'></Moneys>
							</div>
							<div style="display:flex">
								<div class="Income">
									<div>进账</div>
									<Moneys  :value='inComeAndOutInfo.in'></Moneys>
								</div>
								<div class="expenditure">
									<div>出账</div>
									<Moneys  :value='inComeAndOutInfo.out'></Moneys>
								</div>
							</div>
							<div class="money_desc">
								<el-row  class='moeny_desc_item' v-for = "i in fundType" :key = "i.icon">
									<el-col :span="7">
										<img :src="'/static/img/'+i.icon+'.png'" style="margin-right:10px">
										<span class="c6">{{ i.name }}</span>
									</el-col>
									<el-col :span="8"  class="moeny_desc_dashed"></el-col>
									<el-col :span="7" :offset="1" style="text-align:right;">
										<Moneys  :value='i.money' :classStyle="['c6','wb','overflow_ellipsis']"></Moneys>
									</el-col>
								</el-row>
							</div>
						</div>
						<div class="money_fixed " v-for="(i,index) in fixedAssets" :key = "index">
							<span style="font-size:14px;width:50%" class="v-m">{{ i.name }}：</span>
							<Moneys  :value='i.money' :class="['v-m']" style="width:50%"></Moneys>
						</div>
						<div class="miniTitle">往来单位</div>
						<div class="intercourse_Company">
							<div class="intercourse_item" v-for = "i in communication" :key = "i.icon" :class="intercourse_">
									<div >
										<img :src="'/static/img/'+i.icon+'.png'" style="margin-right:10px">
										<span class="c6">{{ i.name }}</span>
									</div>
									<div  v-for = "(item,index) in i.child" :key = "index" class="item_money overflow_ellipsis">
										<span class="c9" >{{ item.name }}</span>
										<Moneys  :value='item.money' :classStyle="['c6','wb','flexSize']" style="margin-left:10px;"></Moneys>
									</div>
							</div>
						</div>
					</div>
					<div class="status" v-loading = "loading">
						<el-row >
							<el-col :span='9' >
								<div class="miniTitle">经营状况</div>
							</el-col>
							<el-col :span="15" style="text-align:right;">
								<div style="display:flex;justify-content: flex-end;margin-right:20px">
										<el-select v-model="accountType" placeholder="请选择" size="mini" style="width:110px;" @change="accountTask">
											<el-option label="按月统计" value="1"></el-option>
											<el-option label="按年统计" value="2"></el-option>
											<el-option label="按累计统计" value="3"></el-option>
										</el-select>
										<Accounting-period
										style="margin-left:10px"
										@defaultTime='defaultTime'
										v-if="accountType=='1'&&showAcc"
										:isDaterange='false'
										:size="'mini'">
										</Accounting-period>
										<el-date-picker
										style="width:110px;margin-left:10px"
										 v-if="accountType=='2'"
										 v-model="year"
										 type="year"
										 size="mini"
										 @change="accountTask('2')"
										 placeholder="选择年">
										</el-date-picker>
								</div>
							</el-col>
						</el-row>
						<el-row style="padding-right:20px;">
							<div class="profit">
										<div id='profitCharts' ></div>
										<div class="right_info overflow_ellipsis">
											<div class="profitInfo">
												<div class="f-18" style="width:20%;margin-right:10px;" :style="{'color':this.profit<0?'#FF6010':'#1677FF'}">{{profitText}}</div>
												<Moneys  :value='profit'   style="width:80%" :class="{'errorAcctiveText':this.profit<0}"></Moneys>
											</div>
											<div class="income_expenditure">
												<div style="width:50%">
													<span>收入</span>
													<Moneys  :value='stateOfOperation.incomeMoney' :classStyle="['c6','overflow_ellipsis']"  ></Moneys>
												</div>
												<div style="width:50%">
													<span>支出</span>
													<Moneys  :value='stateOfOperation.expenditureMoney' :classStyle="['c6','overflow_ellipsis']"  ></Moneys>
												</div>
											</div>
										</div>
							</div>
						</el-row>
						<div class="miniTitle">收入</div>
						<div style="padding-right:20px">
							<div class="incomebox">
								<div v-for="(item,index) in stateOfOperation.income" :key="index" class="incomeList" @click="openDialog(item)" :class="[{'errorAcctive':item.money<0},incomeList_num]">
									<div class="c9">{{item.name}}</div>
									<Moneys  :value='item.money' :classStyle="['c6','overflow_ellipsis','wb']"  ></Moneys>
								</div>
							</div>
						</div>
						<div class="miniTitle">支出</div>
						<div style="padding-right:20px">
							<div class="expenditurebox">
									<div v-for="(item,index) in stateOfOperation.expenditure" :key="index" class="expenditureList" @click="openDialog(item)" :class="[incomeList_num]">
										<div class="c9">{{item.name}}</div>
										<Moneys  :value='item.money' :classStyle="['c6','overflow_ellipsis','wb']"  ></Moneys>
									</div>
							</div>
						</div>
					</div>
				</div>
			</el-col>
			<el-col  :xl="7" >
				<div class="home_right">
					<el-row>
						<el-col :span="12"><div class="miniTitle">预估所得税趋势</div></el-col>
						<el-col :span="12" >
							<div class="estimateTotal">
								<span  class="c9">预估所得税</span>
								<span  class="overflow_ellipsis c6 wb">{{filterMoeny(estimatedTotal)}}</span>
							</div>
						</el-col>
					</el-row>
					<div id='estimateCharts' v-loading = "loading_1"></div>
					<div class="miniTitle">税额比对</div>
					<el-table :data="tableData" class="taxAmount" stripe :class="widthChange">
						<el-table-column prop="name" label="税种"  min-width="170"></el-table-column>
						<el-table-column  label="报表税金" min-width="135">
							<template slot-scope="scope">
								<Moneys  :value="scope.row.money" :classStyle="[]"  :style="{ color:( scope.row.crmMoney !== scope.row.money &&  scope.row.crmMoney !== null)?'#000000':'#666666' }"></Moneys>
							</template>
						</el-table-column>
						<el-table-column  label="实缴税金" min-width="135">
							<template slot-scope="scope">
								<Moneys  :value="scope.row.crmMoney" :classStyle="[]"  :style="{ color:( scope.row.crmMoney !== scope.row.money &&  scope.row.crmMoney !== null)?'#FF6010':'' }"></Moneys>
							</template>
						</el-table-column>
					</el-table>
				 </div>
			</el-col>
		</el-row>
        <common-functions :showVisible.sync="dialogVisible_CYGN" @getMenuList = 'getMenuList'></common-functions>
		<!-- 经营状况 弹框-->
		<EditorialRules ref="editorialRules"
			:showVisible.sync="dialogVisible_"
			:row='row'
			@handleAddSuccessMessage='handleAddSuccessMessage'>
		</EditorialRules>
    <!-- 问题反馈 -->
    <ExistingProblems ref="ExistingProblems" />
  </div>
</template>

<script>
import axios from 'Axios';
import AccountingPeriod from '@/components/dialog/accountingPeriod'
import EditorialRules from '@/components/dialog/editorialRules'
import PublicTable from '@/components/publicTable'
import echarts from 'echarts'
import commonFunctions from '@/components/dialog/commonFunctions'
import ExistingProblems from '@/components/dialog/ExistingProblems'
import Moneys from '@/components/moneys'
import { findRejects } from '@/api'
// import {filterMoeny} from '@/assets/utils/currencyFormat'
import { findHomePageInfo,findEstimatedIncome,inComeAndOut } from "@/api"
export default {
	components: {
		EditorialRules,
		commonFunctions,
		PublicTable,
		AccountingPeriod,
		Moneys,
    ExistingProblems
	},
	data(){
		return {
			estimatedTotal:0,
			incomeList_num:'',
			intercourse_:'',
			widthChange:'',
			showAcc:false,
			year:'',  /** 统计年 */
			month:'',  /** 统计日期 */
			dialogVisible_:false,
			row:{},
			expenditureList:[],
			incomeList:[],
			tableData:[],
			accountValue:'',  //统计月、年
			accountType:'1',  //统计方式
			isFirstActive: false,
			isDefaultShow: false,         // 触发子组件的请求事件
			lines:true,
			nowIndex: 0,              // 当前点击导航下标
			graphicalDataList: [],  // 所有请求折线数据，防止重复请求
			ajaxGetListId:'',    // 当前当行ID
			ajaxGetList: [],       // 获取财务状况导航
			commonList: [],         // 常用功能列表
			dialogVisible_CYGN: false,  // 常用功能是否显示
			dialogVisible_CWZK: false,   // 财务状况弹框是否显
			loading: false, // 中间loading
      loading_1: false, // 预估所得税loading
			pieChartData: {},  // 饼状图数据
			prices:0,
			numList:[],
			colorList:['#20bd90', '#feca57', '#6c5ce7', '#fe5578', '#268aff','orange'],
      loadingLine:false,
      inComeAndOutInfo: {}, // 资金总览金额
      fundType: [], // 资金总览数据
      communication: [], // 往来单位
      fixedAssets: [], // 固定资产
      stateOfOperation: {},  // 经营状况
      isProblemRole: [], // 问题反馈的权限
		}
	},
	created(){

		this.getZhangTao()
		// this.init()
	},
	computed: {
	profitText(){
		return this.profit<0?'亏损':'盈利'
	},
	getClickCache() {
			return this.$store.state.loadstatus.isClickCache;
	},
    profit() {
		return (this.stateOfOperation.incomeMoney - this.stateOfOperation.expenditureMoney).toFixed(2)
    },
    ProfitPosition() {
      if(this.profit>0) {
        return ['80']
      }else if(this.profit<0){
        return ['30']
      }else {
        return ['50']
      }
    },
	},
	activated() {
    this._findEstimatedIncome();
    this.getButton(['ac:show:periodIssues'],'isProblemRole')
	},
	methods:{

    // 获取按钮权限
    getButton(arr, key) {
      let params = {
        permissions: arr.join(","),
      };
      try {
        this.$http.post("sys/menu/findPermissionMenu", params).then((res) => {
          if (res && res.data.code == 1) {
            if (res.data.data.length) {
              this[key] = res.data.data;
              this.getRejectList()
            }
          }
        });
      } catch (e) {}
    },
    // 获取问题列表数据  有值就直接弹出
    async getRejectList() {
      try {
        const { data } = await findRejects({
          cid: JSON.parse(sessionStorage.getItem("cid")),
          isHistory: false,
        })
        if(data.code == 1 && data.data.length) {
          this.problemFeedback()
        }
      } catch (error) {}
    },
    // 打开问题反馈
    problemFeedback() {
      this.$refs.ExistingProblems.handleOpen()
    },
		/**filterMoeny 金额转换 */
		filterMoeny(data){
			   let reg = /[-]/
			   if(!data){
				  return data
			   }else {
				  let str = String(data).replace(reg,'')
				  if(Number(str)>10000){
						return  (data / 10000).toFixed(2) + '万';
				  }else{
					return data
				  }
			   }
		},
		/** 首页初始化获取账套信息 */
		getZhangTao(){
				axios.post('createAccountSet/getBook',{}).then(res=>{
					if(res.data.code == '1') {
						sessionStorage.setItem('accountInfo', JSON.stringify(res.data.data));
						sessionStorage.setItem('superPreventOperation', JSON.stringify(res.data.msg));
						this.showAcc=true
					}else {
						reject()
					}
				})
		},
		// 1/2/3  月/年/累积
		accountTask(e){
			if(e==1) {
				this.accountValue = this.month
			}else if(e==2){
				this.accountValue = new Date(this.year).getFullYear()
			}else {
				this.accountValue=''
			}
			this._inComeAndOut();
     		this._findHomePageInfo();
		},
		defaultTime(data){
			const year = new Date(data.yearPeriodsStart)
			const month= this.$util.formatDate.format(data.yearPeriodsStart , 'yyyyMM')
			this.accountValue = month
			this.year = year
			this.month = month
      		this.init();
		},
		openDialog(item){
      this.row = item;
			this.dialogVisible_=true
		},
		handleAddSuccessMessage(){

		},
		/** 预估所得趋势图形 */
		getEstimateCharts ({ xAxisDaya, data ,left}){
			let myChart = echarts.init(document.getElementById('estimateCharts'));
			let option = {
			grid:{
				top:'20px',
				left,
				right:'20px',
				bottom:'20px'
			},
			  tooltip: {
				trigger: "axis",
				formatter: '{b0}:{c0} 元',
			},
			xAxis: [
				{
				type: "category",
				boundaryGap: false,
				axisLine: {
					//坐标轴轴线相关设置。数学上的x轴
					show: true,
					lineStyle: {
					color: "rgb(243,240,255)",
					width:2
					},
				},
				axisLabel: {
					interval: 0,
					//坐标轴刻度标签的相关设置
					textStyle: {
					color: "#9B9B9B",
					margin: 1,
					},
				},
				axisTick: {
					show: false,
				},
				data: xAxisDaya,
				},
			],
			yAxis: [
				{
			    min:0,
				splitNumber:5,
				type: "value",
				splitLine: {
					show: true,
					lineStyle: {
					color: "rgb(243,241,250)",
					type:'dashed',
					},
				},
				axisLine: {
					show: true,
					lineStyle: {
					color: "rgb(243,240,255)",
					width:2,
					},
				},
				axisLabel: {
					margin: 20,
					textStyle: {
					color: "#9B9B9B",
					},
				},
				axisTick: {
					show: false,
				},
				},
			],
			series: [
				{
				symbol:'none',
				name: "注册总量",
				type: "line",
				lineStyle: {
					normal: {
					color: "#20BD90", // 线条颜色
					width:2
					},
				},
				areaStyle: {
					//区域填充样式
					normal: {
					//线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
					color: new echarts.graphic.LinearGradient(0,0,0,1,
						[
						{   offset: 0,
							color: "rgba(67, 224, 195, .2)",},
						{
							offset: 0.9,
							color: "rgba(255,255,255)",
						},
						],
						false
					),
					},
				},
				data,
				},
			],
			};
			myChart.setOption(option);
			window.onresize=function(){
				      myChart.resize();
			}
		},
		/** 渲染经营状况图形 */
		getProfitCharts (){
			let myChart = echarts.init(document.getElementById('profitCharts'));
			let zzData = this.profit
			const _ = this
			let option = {
				tooltip:{
			    	show: true,
			    },
				series: [
					{
						tooltip: {
							show: false,
						},
						name: "wrap",
						type: "pie",
						hoverAnimation: false,
						legendHoverLink: false,
						center: ["50%", "80%"],
						radius: '5%',
						z: 5,
						label: {
							normal: {
							show: false,
							position: "center",
							},
							emphasis: {
							show: false,
							},
						},
						labelLine: {
							normal: {
							show: false,
							},
						},
						data: [
							{
							value: 100,
							itemStyle: {
								normal: {
								color: "#fff",
								},
								emphasis: {
								color: "#fff",
								},
							},
							},
						],
    				},
					{
						tooltip: {
							show: false,
						},
						name: "wrap",
						type: "pie",
						hoverAnimation: false,
						legendHoverLink: false,
						center: ["50%", "80%"],
						radius: ['10%','5%'],
						z: 5,
						label: {
							normal: {
							show: false,
							position: "center",
							},
							emphasis: {
							show: false,
							},
						},
						labelLine: {
							normal: {
							show: false,
							},
						},
						data: [
							{
							value: 100,
							itemStyle: {
								normal: {
								color: "#E6E6E6",
								},
								emphasis: {
								color: "#E6E6E6",
								},
							},
							},
						],
    				},
				    {
				        name: '指针',
				        type: 'gauge',
				        z: 0,
				        radius: '50%',
				        startAngle: 180,
				        endAngle: 0,
				        center: ["50%", "80%"], //整体的位置设置
				         tooltip:{
				        	show:true,
				        	 textStyle: {
					            color: '#fff'
					        },
				        	backgroundColor:'#243145',
				        	formatter: function(param) {
					        	return  _.filterMoeny(zzData) + '元';
					        }
				        },
				        axisLine: {
				            lineStyle: { // 属性lineStyle控制线条样式//指针颜色
				                color: [
				                    [1, '#FF6010']
				                ],
				                width:0,
				            }
				        },
				        axisTick: {
				            show: false
				        },
				        splitLine: {
				            show: false
				        },

				        axisLabel: {
				           show: false,
				        },
				        data: this.ProfitPosition, //指针位置
				        pointer: {
				            show: true,
				            width: 3,
				            length: '155%'
				        },
				        detail: {
				            show: 0
				        }
				    },
					{
				        name: '外层盘',
				        type: 'gauge',
				        radius: '160%',
				        startAngle: 180,
				        endAngle: 0,
						z:0,
				        center: ["50%", "95%"], //整体的位置设置
				        axisLine: {
				            lineStyle: { // 属性lineStyle控制线条样式//控制外圈位置
				                width: 13,
								color: [
									[1,new echarts.graphic.LinearGradient(0, 1, 1, 0, [
										{offset: 0.5,color: "transparent",},
										{offset:0.6,color: "transparent",},
										{offset: 1,color: "transparent",},
									]),
									],
								],
								width: 8,
				            }
				        },
				        axisTick: {
				            show: false
				        },
				        splitLine: {
				            show: false
				        },
				       axisLabel: {
		                show: true,
		                fontSize: 12,
		                fontWeight: 'bold',
		                color:'#999999',
		                distance: -30,
		                formatter:function(val){
				                    var lll = '';
				                    switch (val) {
				                        case 0:
				                           lll='负';
				                            break;
				                        case 100:
				                            lll='正';
				                            break;
				                        default:
				                            break;
				                    }
				                    return lll;
				         }
				        },
				        pointer: {
				            show: false
				        },
				        data: [{
				            show: true,
				            value: '0.9'
				        }],
				        detail: {
				            show: 0
				        }
				    },
					{
				        name: '外层盘',
				        type: 'gauge',
				        radius: '160%',
				        startAngle: 180,
				        endAngle: 0,
						z:10,
				        center: ["50%", "85%"], //整体的位置设置
				        axisLine: {
				            lineStyle: { // 属性lineStyle控制线条样式//控制外圈位置
				                width: 13,
								color: [
									[1,new echarts.graphic.LinearGradient(0, 1, 1, 0, [
										{offset: 0.5,color: "#1677FF",},
										{offset:0.6,color: "#00BFD0",},
										{offset: 1,color: "#00BFD0",},
									]),
									],
								],
								width: 8,
				            }
				        },
				        axisTick: {
				            show: false
				        },
				        splitLine: {
				            show: false
				        },
				       axisLabel: {
		                show: true,
		                fontSize: 12,
		                fontWeight: 'bold',
		                color:'#999999',
		                distance: -60,
		                formatter:function(val){
				                    var lll = '';
				                    return lll;
				         }
				        },
				        pointer: {
				            show: false
				        },
				        data: [{
				            show: true,
				            value: '0.9'
				        }],
				        detail: {
				            show: 0
				        }
				    },
					{
						type: 'gauge',
						name: '业务指标',
						radius:'130%',
						startAngle:'0',
						endAngle:'80',
						splitNumber:'8',
						center: ["50%", "80%"], //整体的位置设置
						pointer:{
							show:false
						},
						title:{
						    show:false
						},
						detail: {
			    			show:false
						},
						data: [{value: 95, name: '完成率'}],
						axisLine:{
							lineStyle: {
								width: 20,
								opacity: 0
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: true,
							length:8,
							lineStyle: {
								color: '#00BFD0',
								width: 3,
								type: 'solid',
							},
						},
						 axisLabel: {
			                show: true,
			                fontSize: 12,
			                color:'#999',
			                distance: 10,
			                formatter:function(val){
			                    var llll = '';
			                    switch (val) {
			                        case 0:
			                           llll='100%';
			                            break;
			                        default:
			                            break;
			                    }
			                    return llll;
			                }
			            },
					},
					{
						type: 'gauge',
						name: '业务指标',
						radius:'130%',
						startAngle:'100',
						endAngle:'180',
						splitNumber:'8',
						center: ["50%", "80%"], //整体的位置设置
						pointer:{
							show:false
						},
						title:{
						    show:false
						},
						detail: {
			    			show:false
						},
						data: [{value: 95, name: '完成率'}],
						axisLine:{
							lineStyle: {
								width: 20,
								opacity: 0
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: true,
							length:8,
							lineStyle: {
								color: '#1677FF',
								width: 3,
								type: 'solid',
							},
						},
						 axisLabel: {
			                show: true,
			                fontSize: 12,
			                color:'#999',
			                distance: 10,
			                formatter:function(val){
			                    var llll = '';
			                    switch (val) {
			                        case 100:
			                           llll='100%';
			                            break;
			                        default:
			                            break;
			                    }
			                    return llll;
			                }
			            },
					},
					{
						type: 'gauge',
						name: '业务指标',
						radius:'67%',
						startAngle:'90',
						endAngle:'100',
						splitNumber:'0',
						center: ["50%", "53%"], //整体的位置设置
						pointer:{
							show:false
						},
						title:{
						    show:false
						},
						detail: {
			    			show:false
						},
						data: [{value: 95, name: '完成率'}],
						axisLine:{
							lineStyle: {
								width: 20,
								opacity: 0
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: true,
							length:1,
							lineStyle: {
								color: '#fff',
								width: 1,
								type: 'solid',
							},
						},
						axisLabel: {
							show: true,
			                fontSize: 12,
			                color:'#999',
			                distance: 10,
			                formatter:function(val){
			                   return "0";
			                }
						}
					},
				]
			}
			myChart.setOption(option);
			window.onresize=function(){
				      myChart.resize();
			}
		},
	init(){
	  this._inComeAndOut();
      this._findHomePageInfo();
	//   this._findEstimatedIncome()
	},
    /* 获取资金总览 */
    async _inComeAndOut() {
      try{
         // type 1 按期 2 按年 3 累计, yearPeriod 期数 默认为当前的期间
        const { data } = await inComeAndOut({ type: this.accountType, yearPeriod: this.accountValue});
        this.inComeAndOutInfo = {};
        if(data.code == "1") {
          this.inComeAndOutInfo = data.data;
		  this.filterMoeny(data.data)
        }
      }catch(e){
        this.loading = false;
      }

    },
    /* 获取预估所得税趋势 */
    async _findEstimatedIncome() {
      try{
        this.loading_1 = true;
        const { data } = await findEstimatedIncome();
		this.estimatedTotal = data.data.money[data.data.money.length-1]||0
		let left ='80px'
		let str = String(Math.floor(Math.max(...data.data.money)))
		if( str.length>7){
			left ='100px'
		}else if(str.length<6){
			left ='60px'
		}else {
			left ='80px'
		}
        this.getEstimateCharts ({ xAxisDaya: data.data.month, data: data.data.money ,left})
      }catch(e){
        this.getEstimateCharts ({ xAxisDaya: [], data: [] ,left})
      }finally {
        this.loading_1 = false;
      }

    },
    /* 获取首页信息 1,资金类型;2,报表税金;3, 固定资产;4,往来单位;5,经营状况 */
    async _findHomePageInfo() {
      // type 1 按期 2 按年 3 累计, yearPeriod 期数 默认为当前的期间
      try{
        this.loading = true;
        const { data } = await findHomePageInfo({ type: this.accountType, yearPeriod: this.accountValue});
        this.loading = false;
        if(data.code == "1") {
          this.fundType = data.data.fundType; // 资金总览
          this.communication = data.data.communication; // 往来单位
          this.fixedAssets = data.data.fixedAssets; // 固定资产
          this.stateOfOperation = data.data.stateOfOperation; // 经营状况
          this.tableData = data.data.statementTax;
        }
      }catch(e){
        this.loading = false;
      }finally {
        this.getProfitCharts()
      }

    },
		// 点击当前财务状况切换
		handleClickChange(row,index) {
			this.ajaxGetListId = row.id;
			this.nowIndex = index;
			this.getGraphicalDataById(row.id,index)
		},
		// 根据ID获取折线图
		getGraphicalDataById(id,index) {
			if(JSON.stringify(this.graphicalDataList[index])=="{}" ) {
				this.$http.post('financialSetting/ajaxGetChart' , {id: id}).then(res=>{
					if(res && res.data.code) {
						this.graphicalDataList[index] = res.data.data;
						this.getEchartsLine();
					}
				})
			}else {
				this.getEchartsLine();
			}

		},
		// 开启财务状况设置
		financialSituationShow() {
			const prevent =  this.$getSessionStorage('superPreventOperation');
			if(prevent) {
				this.$store.commit('SUPERPREVENTFUNCTION',true);
				return;
			}
			this.dialogVisible_CWZK = true;
		},
		// 点击常用功能跳转
		handleClickJump(row) {
			if(!row.permission) {
				return this.$message.error('无权访问！');
			}
			const prevent =  this.$getSessionStorage('superPreventOperation');
			if(row.href == "/addVoucher" && prevent) {
				this.$store.commit('SUPERPREVENTFUNCTION',true);
				return;
			}

			this.$router.push({path: row.href});
		},
		// 获取常用功能
		getMenuList(data) {
			if(data.length) {
				this.commonList = data;
			}
		} ,
		// 常用功能设置显示
		CommonFunctionsShow() {
			const prevent =  this.$getSessionStorage('superPreventOperation');
			if(prevent) {
				this.$store.commit('SUPERPREVENTFUNCTION',true);
				return;
			}
			this.dialogVisible_CYGN = true;
		},

		linesChange(){
			const _=this;
			_.lines = !_.lines;
			_.$nextTick(()=>{
				if(_.lines){
					this.getEchartsPie();
				}else{
					this.getLineCharts();
				}
			});
		},
		// 财务状况
		getEchartsPie(){

			let myChart = echarts.init(document.getElementById('echart_left'));

			let option = {
				tooltip : {
					trigger: 'item',
					formatter: "{b} : {c} ({d}%)"
				},
				legend: {
					show:false,
					icon:'none',
					itemWidth: 5,
					itemHeight: 10,
					type: 'scroll',
					left: 50,bottom: 33,
					selectedMode:false,
					data:this.pieChartData.name,
				},
				series : [
					{
						name: '本月利润',
						type: 'pie',
						radius : '70%',
						center: ['50%', '40%'],
						data: this.pieChartData.value,
						 "label": {
				            "normal": {
				                "show": false,
				               "formatter": "{c}"
				            },
				            "emphasis": {
				                "show":false
				            }
				        },
				        "labelLine": {
				            "normal": {
				                "show": false,
				                "smooth": false,
				                "length": 0,
				                "length2": 0
				            },
				            "emphasis": {
				                "show": false
				            }
				        },
						itemStyle: {
							emphasis: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							},
							normal:{
								color:function(params) {
									var colorList = ['#20bd90', '#feca57', '#6c5ce7', '#fe5578', '#268aff','orange'];
									return colorList[params.dataIndex]
								 },
							}
						}
					}
				]
			};
			myChart.setOption(option);
			window.onresize=function(){
			      myChart.resize();
			 }
		},//
		getLineCharts(){
        const _=this;
        _.loadingLine = true;
        _.$http.post('financialSetting/lineChart',{}).then(res=>{
          _.loadingLine = false;
          if(res && res.data.code == '1'){
              this.getEchartsPieLine(res.data.data);
          };
        }).catch(e=>{
          _.loadingLine = false;
        });
		},
		getEchartsPieLine(datas){////-----------获取趋势图
			let myChart = echarts.init(document.getElementById('echart_left_lines'));
			let option = {
				grid:{
					top:20,
					bottom:30,
					containLabel:true
				},
				xAxis: {
					type: 'category',
					data:datas.month,
				},
				yAxis: {
					type: 'value',
					splitLine: {
						show: true,
						lineStyle:{
						   color: ['#eee'],
						   type: 'solid'
						},
					}
				},
				tooltip: {
					trigger: 'axis',
					formatter: '{b0}:{c0} 元'
				},
				series: [{
					data: datas.money,
					type: 'line',
					smooth: true,
					itemStyle:{
						normal:{
							color:"#12A7FB",
							lineStyle:{color:"#12A7FB"}
						}
					},
					 areaStyle: {
						color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
							offset: 0,
							color: '#d3e6fd'
						}, {
							offset: 1,
							color: '#f6fbfe'
						}])
					},
				}]
			};
			myChart.setOption(option);
			window.onresize=function(){
			      myCharts.resize();
			 }
		},
		getEchartsLine(){
			let myCharts = echarts.init(document.getElementById('echart_right'));
			let option = {
				xAxis: {
					type: 'category',
					data: this.graphicalDataList[this.nowIndex].month,
				},
				yAxis: {
					type: 'value',
					splitLine: {
						show: true,
						lineStyle:{
						   color: ['#eee'],
						   type: 'solid'
						},
					}
				},
				tooltip: {
					trigger: 'axis',
					formatter: '{b0}:{c0} 元'
				},
				series: [{
					data: this.graphicalDataList[this.nowIndex].money,
					type: 'line',
					smooth: true,
					itemStyle:{
						normal:{
							color:"#12A7FB",
							lineStyle:{color:"#12A7FB"}
						}
					},
					 areaStyle: {
						color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
							offset: 0,
							color: '#d3e6fd'
						}, {
							offset: 1,
							color: '#f6fbfe'
						}])
					},
				}]
			};
			myCharts.setOption(option);
			window.onresize=function(){
			      myCharts.resize();
			 }
		},
		// 退回登录页面操作
		goBackLogin() {
			this.$confirm('系统检测到您即将离开首页前往登录页，将为您自动登出，是否继续？', '提示', {
	          confirmButtonText: '确定',
	          cancelButtonText: '取消',
	          type: 'warning'
	        }).then(() => {
	          	this.$http.post('sys/login/exit',{}).then(res=>{
	          		if(res && res.data.code == 1) {
	          			sessionStorage.clear();
						this.$store.commit('CLEARROUTER');
						this.$store.commit('CLEAR_SUBJEXT_STATE');
						this.$store.commit('DEL_ALL_VISITED_VIEWS');
						this.$store.commit('DEL_ALL_CACHED_VIEWS');
						this.$store.commit('CLEAR_YEARPERIODS_INFO');
						this.$router.push({
							path: '/login'
						})
	          		}
				})
	        }).catch(() => {
	          history.pushState(null, null, document.URL);
	          this.$message({
	            type: 'warning',
	            showColse: true,
	            message: '已为您保留当前页'
	          });
	        });
		},
	},
	mounted() {
		if(window.history && window.history.pushState) {
			history.pushState(null, null, document.URL);
			window.addEventListener('popstate', this.goBackLogin, false);
		}
	},
	destroyed () {
	    window.removeEventListener('popstate', this.goBackLogin, false);
	},
	watch: {
		'$route'(to , form) {
			if(to.path == '/home') {
				window.addEventListener('popstate', this.goBackLogin, false);
			}
			if(form.path == '/home') {
				window.removeEventListener('popstate', this.goBackLogin, false);

			}
		}
	}
}
</script>
<style lang="less">
  	@media screen and (min-width:2450px) and (max-width:4096px){
		.moeny_desc_item{
			line-height: 80px !important;
			font-size: .12rem !important;
			.moeny_desc_dashed {
				margin-top: .3rem !important;
			}
		}
  		.incomeList,.expenditureList {
			// margin-right: 16px !important;
			height: 120px !important;
		>div:first-child {
			top: 30px !important;
		}
		>div:last-child {
			bottom: 30px !important;
			}
		}
		.taxAmount {
			td {
				padding: 16px 0 !important;
			}
			th {
				padding: 20px 0 !important;
			}
		}
		.intercourse_item {
			height: 75px !important;
			line-height: 75px !important;
		}

	}
	@media screen and (max-width:1919px){
    #homeMain .left_Content {
      padding-right: 0 !important;
    }
	}
    .flexSize {
		font-size: .1rem;
	}
	.overflow_ellipsis {
		 white-space:nowrap;
       	 overflow:hidden;
         text-overflow:ellipsis;

	}
	.errorAcctiveText {
		color: #FF6010 !important;
	}
	.errorAcctive {
		div {
			color: #FF6010 !important;
		}
		background: rgba(255, 96, 16, 0.1) !important;
	}
	.c9 {
		color: #999;
	}
	.c6 {
		color:#666
	}
	.wb {
		font-weight: bold;
	}
	.v-m{
		vertical-align: middle;
	}
	.miniTitle {
		color: #666;
		font-size: 15px;
		font-weight: bold;
	}
	.f-18 {
		font-size: 18px;
		font-weight: bold;
	}
	#homeMain {
		.left_Content {
				height: calc(100vh - 142px);
				padding-right: 20px;
				margin-bottom: 20px;
				.quick {
					width:100%;
					height: 176px;
					background: #FFFFFF;
					border-radius: 8px;
					margin-bottom: 20px;
					padding: 20px;
					box-sizing: border-box;
					.edit{
						cursor:pointer;
						font-size: .14rem;
						margin-left: .30rem;
						color: #999;
						i{font-size: .18rem;margin-right: .10rem;}
					}
					.quick-items {
						margin-top: 20px;
						display: flex;
						align-items: center;
						overflow: hidden;
						.quick-item {
							cursor: pointer;
							flex: 1;
							padding-left: 30px;
							width: 270px;
							height: 94px;
							line-height: 94px;
							background: rgba(233, 233, 233, 0.26);
							border-radius: 4px;
							margin-right: 20px;
							img {
								margin-right: 10px;
							}
						}
					}
				}
				.content {
					width: 100%;
					height: calc(100% - 196px);
					display: flex;
					.money {
						padding: 20px;
						box-sizing: border-box;
						width: 378px;
						height: 100%;
						background: #FFFFFF;
						overflow: auto;
						border-radius: 8px;
						margin-right: 20px;
						.money_num {
							width: 100%;
							min-height: 320px;
							box-sizing: border-box;
							margin-top: 10px;
							padding: 10px;
							background: rgba(233, 233, 233, 0.11);
							.surplus {
								background-image: url('/static/img/surplus_bg.png');
								background-size: 100%;
								margin-bottom: 10px;
							}
							.surplus,.Income,.expenditure {
								padding: 20px;
								box-sizing: border-box;
								height: 89px;
								color: #fff;
								border-radius: 4px;
							}
							.Income {
								margin-right: 10px;
								background-image: url('/static/img/Income_bg.png');
								background-size: 100%;
							}
							.expenditure {
								background-image: url('/static/img/expenditure_bg.png');
								background-size: 100%;
							}
							.Income,.expenditure {
								flex: 1;
							}
						}
						.money_desc {
							margin-top: 20px;
							width: 100%;
							min-height: 90px;
							overflow: hidden;
							.moeny_desc_item {
								line-height:27px;
								font-size:.14rem;
								.moeny_desc_dashed {
									border:1px dashed #E6E6E6;
									margin-top:.12rem;
								}
							}
						}
						.money_fixed {
							width: 100%;
							height: 50px;
							display: flex;
							text-align: center;
							line-height: 50px;
							margin-bottom: 20px;
							border-radius: 4px;
							padding: 0 50px;
							box-sizing: border-box;
							background-image: url('/static/img/money_fixed.png');
							background-repeat: no-repeat;
							color: #FFFFFF;
						}
						.intercourse_Company {
							width: 100%;
							margin-top: 20px;
							.intercourse_item {
								display: flex;
								height: 37px;
								line-height: 37px;
								padding: 0 10px;
								flex-wrap: nowrap;
								>div {
									flex: 1;
								}
								>div:nth-child(1){
									font-size: 14px;
									>span {
										font-size: 1em;
									}
								}
								>div:nth-child(2) {
									// margin:0 10px;
									margin-right: 10px;
								}
								&:first-child,&:last-child{
									background: rgba(242, 248, 248, 0.6);
								}
								&:nth-child(2) {
									background: #FFFFFF;
								}
								.item_money {
									display: flex;
									font-size: 11px;
									flex-wrap: nowrap;
									// justify-content: space-evenly;
									>span {
										// flex: 1;
										flex-shrink: 0;
									}
								}
							}
						}
					}
					.status {
						overflow: auto;
						padding: 20px 0 20px 20px;
						box-sizing: border-box;
						flex: 1;
						height: 100%;
						background: #FFFFFF;
						border-radius: 8px;
						.profit {
							margin:10px 0px 20px 0px;
							display: flex;
							flex-wrap: wrap;
							justify-content: space-evenly;
							padding: 20px 1rem;
							box-sizing: border-box;
							width: 100%;
							min-height: 182px;
							background: rgba(242, 248, 248, 0.43);
							#profitCharts {
								width: 300px;
								height: 150px;
								margin-right: 40px;

							}
							.right_info {
								width: 200px;
								overflow: hidden;
							}
							.profitInfo {
								width: 100%;
								display: flex;
								color: #1677FF;
								justify-content: space-between;
								padding-top: 40px;
								line-height: 27px;
							}
							.income_expenditure {
								display: flex;
								margin-top: 20px;
								justify-content: space-between;
								color: #999999;
								>div:first-child {
									margin-right: 10px;
								}
							}
						}
						.incomebox {
							margin-bottom: 20px;
							>div:nth-child(4n+4){
									margin-right: 0;
							}
							.incomeList {
								cursor: pointer;
								position: relative;
								display: inline-block;
								margin-top: 10px;
								margin-right: 1.3%;
								width: 24%;
								height: 75px;
								padding: 10px;
								font-size: 14px;
								box-sizing: border-box;
								background: rgba(233, 233, 233, 0.26);
								border-radius: 4px;
								>div {
									position: absolute;
									left:20px;
									font-size: 1em;
								}
								>div:first-child {
									top: 10px;
								}
								>div:last-child {
									bottom: 10px;
								}
							}
						}
						.expenditurebox {
							width: 100%;
							>div:nth-child(4n+4){
									margin-right: 0;
							}
						}
						.expenditureList {
							    cursor: pointer;
								position: relative;
								display: inline-block;
							    padding: 10px;
								margin-top: 10px;
								box-sizing: border-box;
								margin-right: 1.3%;
								width: 24%;
								height: 75px;
								background: rgba(233, 233, 233, 0.26);
								border-radius: 4px;
								font-size: 14px;

								>div {
									position: absolute;
									left:20px;
									font-size: 1em;
								}
								>div:first-child {
									top: 10px;
								}
								>div:last-child {
									bottom: 10px;
								}
						}
					}
				}
		}
			.home_right {
				padding: 20px;
				box-sizing: border-box;
				min-height: calc(100vh - 142px);
				max-height: 100%;
				background: #FFFFFF;
				border-radius: 8px;
				box-sizing: border-box;
				.estimateTotal{
					min-width: 157px;
					padding: 5px ;
					box-sizing: border-box;
					line-height: 34px;
					height: 34px;
					display: flex;
					justify-content: space-between;
					align-items: center;
					background: rgba(233, 233, 233, .26);
					border-radius: 2px;
					float: right;
					>span{
						font-size: .14rem;
						margin: 0 5px;
					}

				}
				#estimateCharts {
					margin:20px 0;
					width: 100%;
					min-height: 180px;
				}
				.taxAmount {
						margin-top: 20px;
						min-height: 470px;
						max-height: calc(100% - 270px);
						overflow: auto;
						td {
							border-bottom: 0;
							padding: 5px 0;
						}
						th {
							border-bottom: 0;
							padding: 8px 0;
							color: #666;
							background: rgba(248, 251, 250, 1);
						}
				}
			}
	}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue